import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatBadgeModule } from '@angular/material/badge';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AppState } from 'src/app/store';

@Component({
  selector: 'app-submenu',
  templateUrl: 'submenu.component.html',
  styleUrls: ['./submenu.component.scss'],
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, MatDialogModule, MatIconModule, MatBadgeModule],
})
export class SubmenuComponent implements OnInit, OnDestroy {
  productosPedidosPendientes!: any[];

  private _unsubscribeAll!: Subject<any>;

  constructor(
    private _dialogRef: MatDialogRef<SubmenuComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _store: Store<AppState>,
    private _router: Router,
  ) {}

  ngOnInit() {
    this._unsubscribeAll = new Subject();
  }

  redirectToOrdenesCompra(): void {
    this._router.navigate(['/ordenes-compra/gestion-compra']);
    this._dialogRef.close({ res: false });
  }

  onNoClick(): void {
    this._dialogRef.close({ res: false });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
